import React from "react";
import { MessageSquareText } from "lucide-react";
import { cn } from "../../../../../lib/utils";
import { SuggestedPrompt } from "../../../types";

interface SuggestedPromptChipsProps {
  prompts: SuggestedPrompt[];
  on_click: (prompt: SuggestedPrompt) => void;
  className?: string;
}

export function SuggestedPromptChips({
  prompts,
  on_click,
  className,
}: SuggestedPromptChipsProps) {
  return (
    <div className={cn("w-full max-w-md", className)}>
      <div className="flex flex-col gap-2">
        {prompts.map((prompt) => (
          <button
            key={prompt.promptName}
            type="button"
            onClick={() => on_click(prompt)}
            className={cn(
              "flex items-start gap-2.5 px-3.5 py-2.5 rounded-lg text-left",
              "border border-slate-200 bg-white",
              "text-sm text-slate-700",
              "hover:border-[#05BDFF]/40 hover:bg-[#05BDFF]/5",
              "transition-colors duration-150",
              "focus:outline-none focus:ring-2 focus:ring-[#05BDFF]/30 focus:ring-offset-1"
            )}
          >
            <MessageSquareText className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#05BDFF]" />
            <span className="leading-snug">{prompt.displayLabel}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default SuggestedPromptChips;
